import { BaseModel } from './base.model'
import * as _ from 'lodash'
import { Constants } from 'config'

export class HubCoursePremoderation extends BaseModel<HubCoursePremoderation> {
   static DEFAULT_ATTRIBUTES = {}

  id: number
  centerId: number
  programId: number
  _destroy: boolean
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/hub-course-premoderation.model.ts